import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../Miscelania/RequestApi';

import { Link } from 'react-router-dom';
import { Tabs, Tab } from 'react-bootstrap';
import Topo from '../Layout/Topo';
import Overlay from '../Miscelania/Overlay';

import InputMask from 'react-input-mask';
import Select from 'react-select';
import getLocale from '../../i18n/getLocale';

// Tabs

class StaffRfmsReportAdmEdit extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open',        
      },
      redirect_url: false,
      loaded: 0,
      key: 1,
      data: {},
      revisions_data: {},
      inputs: {},
      fatigues: {},
      data_permission: 1,
    };
    //Handlers
    this.handleAlert = this.handleAlert.bind(this);
    this.handleLoaded = this.handleLoaded.bind(this);
    this.handleMessage = this.handleMessage.bind(this);

    this.createRevision = this.createRevision.bind(this);
    this.confirmCreate = this.confirmCreate.bind(this);
    this.loadData = this.loadData.bind(this);
    
    this.locale = getLocale();
  }

  // Handlers
  handleChangeData (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }

  handleSelectChange(name, event) {
    var change = {};
    var data_temp = [];
    var self = this;
    Object.keys(this.state.inputs).map(function(k) {
      if(self.state.inputs[k].id === name) {
        change = {
          value: event.label,
          value_input: event.value,
          id: self.state.inputs[k].id,
          name: self.state.inputs[k].name,
          type_str: self.state.inputs[k].type_str,
          type: self.state.inputs[k].type,
          fatigue_options: self.state.inputs[k].fatigue_options,
          operator: self.state.inputs[k].operator,
          hour_points: self.state.inputs[k].hour_points,
          quantity_points: self.state.inputs[k].quantity_points,
          point_limit: self.state.inputs[k].point_limit,
          required: self.state.inputs[k].required,
          max_points: self.state.inputs[k].max_points,
          min_points: self.state.inputs[k].min_points,
          aps_day: self.state.inputs[k].aps_day,
          hours_day: self.state.inputs[k].hours_day,
          nocturnal_extra_points: self.state.inputs[k].nocturnal_extra_points,
          reduction_points: self.state.inputs[k].reduction_points,
          extra_hours: self.state.inputs[k].extra_hours,
          automation_type: self.state.inputs[k].automation_type,
          limit_extra_hours_week: self.state.inputs[k].limit_extra_hours_week,
          limit_extra_hours_month: self.state.inputs[k].limit_extra_hours_month,
          day_limit_extra_hours_week: self.state.inputs[k].day_limit_extra_hours_week,
          day_limit_extra_hours_month: self.state.inputs[k].day_limit_extra_hours_month,
          automation_type_id: self.state.inputs[k].automation_type_id,
          automation_field: self.state.inputs[k].automation_field,
          automation_type: self.state.inputs[k].automation_type,
          automation_type_name: self.state.inputs[k].automation_type_name,
          api_type: self.state.inputs[k].api_type,
        };
        
      } else {
        change = {
          value: self.state.inputs[k].value,
          value_input: self.state.inputs[k].value_input,
          id: self.state.inputs[k].id,
          name: self.state.inputs[k].name,
          type_str: self.state.inputs[k].type_str,
          type: self.state.inputs[k].type,
          fatigue_options: self.state.inputs[k].fatigue_options,
          operator: self.state.inputs[k].operator,
          hour_points: self.state.inputs[k].hour_points,
          quantity_points: self.state.inputs[k].quantity_points,
          point_limit: self.state.inputs[k].point_limit,
          required: self.state.inputs[k].required,
          max_points: self.state.inputs[k].max_points,
          min_points: self.state.inputs[k].min_points,
          aps_day: self.state.inputs[k].aps_day,
          hours_day: self.state.inputs[k].hours_day,
          nocturnal_extra_points: self.state.inputs[k].nocturnal_extra_points,
          reduction_points: self.state.inputs[k].reduction_points,
          extra_hours: self.state.inputs[k].extra_hours,
          automation_type: self.state.inputs[k].automation_type,
          limit_extra_hours_week: self.state.inputs[k].limit_extra_hours_week,
          limit_extra_hours_month: self.state.inputs[k].limit_extra_hours_month,
          day_limit_extra_hours_week: self.state.inputs[k].day_limit_extra_hours_week,
          day_limit_extra_hours_month: self.state.inputs[k].day_limit_extra_hours_month,
          automation_type_id: self.state.inputs[k].automation_type_id,
          automation_field: self.state.inputs[k].automation_field,
          automation_type: self.state.inputs[k].automation_type,
          automation_type_name: self.state.inputs[k].automation_type_name,
          api_type: self.state.inputs[k].api_type,
        };
      }
      data_temp.push(change);
    });
    this.setState({inputs: data_temp});
  }

  handleChange (name, event) {
    var change = {};
    var data_temp = [];
    var self = this;
    Object.keys(this.state.inputs).map(function(k) {
      if(self.state.inputs[k].id === name) {

        change = {
          value: event.target.value,
          value_input: event.target.value,
          id: self.state.inputs[k].id,
          name: self.state.inputs[k].name,
          type_str: self.state.inputs[k].type_str,
          type: self.state.inputs[k].type,
          fatigue_options: self.state.inputs[k].fatigue_options,
          operator: self.state.inputs[k].operator,
          hour_points: self.state.inputs[k].hour_points,
          quantity_points: self.state.inputs[k].quantity_points,
          point_limit: self.state.inputs[k].point_limit,
          required: self.state.inputs[k].required,
          max_points: self.state.inputs[k].max_points,
          min_points: self.state.inputs[k].min_points,
          aps_day: self.state.inputs[k].aps_day,
          hours_day: self.state.inputs[k].hours_day,
          nocturnal_extra_points: self.state.inputs[k].nocturnal_extra_points,
          reduction_points: self.state.inputs[k].reduction_points,
          extra_hours: self.state.inputs[k].extra_hours,
          automation_type: self.state.inputs[k].automation_type,
          limit_extra_hours_week: self.state.inputs[k].limit_extra_hours_week,
          limit_extra_hours_month: self.state.inputs[k].limit_extra_hours_month,
          day_limit_extra_hours_week: self.state.inputs[k].day_limit_extra_hours_week,
          day_limit_extra_hours_month: self.state.inputs[k].day_limit_extra_hours_month,
          automation_type_id: self.state.inputs[k].automation_type_id,
          automation_field: self.state.inputs[k].automation_field,
          automation_type: self.state.inputs[k].automation_type,
          automation_type_name: self.state.inputs[k].automation_type_name,
          api_type: self.state.inputs[k].api_type,
        };
        
      } else {
        change = {
          value: self.state.inputs[k].value,
          value_input: self.state.inputs[k].value_input,
          id: self.state.inputs[k].id,
          name: self.state.inputs[k].name,
          type_str: self.state.inputs[k].type_str,
          type: self.state.inputs[k].type,
          fatigue_options: self.state.inputs[k].fatigue_options,
          operator: self.state.inputs[k].operator,
          hour_points: self.state.inputs[k].hour_points,
          quantity_points: self.state.inputs[k].quantity_points,
          point_limit: self.state.inputs[k].point_limit,
          required: self.state.inputs[k].required,
          max_points: self.state.inputs[k].max_points,
          min_points: self.state.inputs[k].min_points,
          aps_day: self.state.inputs[k].aps_day,
          hours_day: self.state.inputs[k].hours_day,
          nocturnal_extra_points: self.state.inputs[k].nocturnal_extra_points,
          reduction_points: self.state.inputs[k].reduction_points,
          extra_hours: self.state.inputs[k].extra_hours,
          automation_type: self.state.inputs[k].automation_type,
          limit_extra_hours_week: self.state.inputs[k].limit_extra_hours_week,
          limit_extra_hours_month: self.state.inputs[k].limit_extra_hours_month,
          day_limit_extra_hours_week: self.state.inputs[k].day_limit_extra_hours_week,
          day_limit_extra_hours_month: self.state.inputs[k].day_limit_extra_hours_month,
          automation_type_id: self.state.inputs[k].automation_type_id,
          automation_field: self.state.inputs[k].automation_field,
          automation_type: self.state.inputs[k].automation_type,
          automation_type_name: self.state.inputs[k].automation_type_name,
          api_type: self.state.inputs[k].api_type,
        };
      }
      data_temp.push(change);
    });
    this.setState({inputs: data_temp});
  }
  
  handleNavTab(state, key) {
    var change = {};
    change[state] = key;
    this.setState(change);
    this.setState({overlay: {message: '', type: '', status: ''}});
  }

  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }

  handleLoaded(state) {
    if(this.state.loaded !== 2) {
      this.setState({loaded: state});      
    }
  }

  handleMessage () {
    var message = localStorage.getItem("verify_message");
    if (message !== null && typeof message !== 'undefined') {
      message = JSON.parse(message);
      var self = this;
      self.setState({overlay: {message: message.alert_message, type: message.alert_type, status: 'open'}});
      localStorage.removeItem("verify_message");
    }
  }

  //LM
  componentDidMount () {
    this.refs.request_api.header();
  }

  componentDidUpdate(prevProps, prevState) {
    if(this.state.loaded === 1 && prevState.loaded === 0) {
      this.setState({loaded: 2}, this.loadData());
    }
  }

  loadData (event) {
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      var url = config.get('api') + '/relatorio-de-fadiga/'+self.props.match.params.id;
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url', '/contratos');
        if (responseJson.status === 'success') {
          if (responseJson.data.fatigues === null || typeof responseJson.data.fatigues === 'undefined') {
            fetch(config.get('api') + '/parametros-de-fadiga/relatorio-de-fadiga', { method: 'GET', mode: 'cors', headers: value }).then((responseSimple) => responseSimple.json()).catch((error) => { console.error(error); }).then((responseSimpleJson) => {
              self.refs.request_api.validate(responseSimpleJson);
              if (responseSimpleJson.status === 'success') {
                var change = {};
                var data_temp = [];
                Object.keys(responseSimpleJson.data.params).map(function(k) {
                  var change = {
                    value: null,
                    id: responseSimpleJson.data.params[k].id,
                    name: responseSimpleJson.data.params[k].name,
                    type_str: responseSimpleJson.data.params[k].type_str,
                    type: responseSimpleJson.data.params[k].type,
                    fatigue_options: responseSimpleJson.data.params[k].fatigue_options,
                    operator: responseSimpleJson.data.params[k].operator,
                    hour_points: responseSimpleJson.data.params[k].hour_points,
                    quantity_points: responseSimpleJson.data.params[k].quantity_points,
                    point_limit: responseSimpleJson.data.params[k].point_limit,
                    required: responseSimpleJson.data.params[k].required,
                    max_points: responseSimpleJson.data.params[k].max_points,
                    min_points: responseSimpleJson.data.params[k].min_points,
                    aps_day: responseSimpleJson.data.params[k].aps_day,
                    hours_day: responseSimpleJson.data.params[k].hours_day,
                    nocturnal_extra_points: responseSimpleJson.data.params[k].nocturnal_extra_points,
                    reduction_points: responseSimpleJson.data.params[k].reduction_points,
                    extra_hours: responseSimpleJson.data.params[k].extra_hours,
                    automation_type: responseSimpleJson.data.params[k].automation_type,
                    limit_extra_hours_week: responseSimpleJson.data.params[k].limit_extra_hours_week,
                    limit_extra_hours_month: responseSimpleJson.data.params[k].limit_extra_hours_month,
                    day_limit_extra_hours_week: responseSimpleJson.data.params[k].day_limit_extra_hours_week,
                    day_limit_extra_hours_month: responseSimpleJson.data.params[k].day_limit_extra_hours_month,
                    automation_type_id: responseSimpleJson.data.params[k].automation_type_id,
                    automation_field: responseSimpleJson.data.params[k].automation_field,
                    automation_type: responseSimpleJson.data.params[k].automation_type,
                    automation_type_name: responseSimpleJson.data.params[k].automation_type_name,
                    api_type: responseSimpleJson.data.params[k].api_type,
                  };
                  data_temp.push(change);
                });
                self.setState({inputs: data_temp});
              }
            })
            self.setState({data: responseJson.data});
            self.setState({fatigues: responseJson.data.staff_rfms_report_fatigues});
          } else {
            self.setState({data: responseJson.data});
            self.setState({inputs: responseJson.data.fatigues});
            self.setState({fatigues: responseJson.data.staff_rfms_report_fatigues});
          }
        }
      }).then(() => {
      var url = config.get('api') + '/relatorio-de-fadiga/revisoes/'+self.props.match.params.id;
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson);
        if (responseJson.status === 'success') {
          self.setState({revisions_data: responseJson.data});
        }
      }).then(() => {
      var url = config.get('api') + '/verificar/permissao/administrativo/criar-revisao/'+self.props.match.params.id+'/'+self.props.match.params.staff_id+'/'+self.props.match.params.applicability_id;
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson);
        if (responseJson.status === 'success') {
          self.setState({staff_name: responseJson.staff_name});
          self.setState({data_permission: responseJson.data});
        }
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
        if (typeof event === 'undefined') {
          self.handleMessage();
        } else {
          self.handleAlert(event.message, event.status, 'open');
        }
      }); /* Overlay */ }); /* Revisões */ }); /* Verificar se é permitido criar revisões */ 
    });
  }

  confirmCreate(event) {
    event.preventDefault();
    var self = this;
    var confirmed = 0;
    Object.keys(self.state.inputs).map(function(k) {
      if (self.state.inputs[k].value !== null && typeof self.state.inputs[k].value !== 'undefined') {
        var value = self.state.inputs[k].value;
        if (self.state.inputs[k].type == 'hour') {
          var arr = value.split(':');
          value = parseFloat(parseInt(arr[0], 10) + '.' + parseInt((arr[1]/6)*10, 10));
          value = value * self.state.inputs[k].hour_points;
        } else if(self.state.inputs[k].type == 'quantity') {
          value = value * self.state.inputs[k].quantity_points;
        }
        
        if (self.state.inputs[k].max_points !== null) {
          if (value > self.state.inputs[k].max_points) {
            var confirm = window.confirm(self.locale.RelatoriosDeFadiga.EditarRelatorioDeFadigaAdministrador.noParametroAPontuacaoMaximaFoiUltrapassada(self.state.inputs[k].name));
            if (confirm) {
              if (confirmed !== null) {
                confirmed++;
              }
            } else {
              confirmed = null;
            }
          }
        }
        if (self.state.inputs[k].min_points !== null) {
          if (value < self.state.inputs[k].min_points) {
            var confirm = window.confirm(self.locale.RelatoriosDeFadiga.EditarRelatorioDeFadigaAdministrador.noParametroAPontuacaoMinimaNaoFoiAtingida(self.state.inputs[k].name));
            if (confirm) {
              if (confirmed !== null) {
                confirmed++;
              }
            } else {
              confirmed = null;
            }
          }
        }
      }
    });
    if (confirmed >= 0 && confirmed !== null ) {
      this.createRevision();
    }
  }

  createRevision() {
    this.handleAlert('', '', 'open');
    var datasave = {
      inputs: this.state.inputs,
      date_str: this.state.data.date_str,
      revision_id: this.props.match.params.id,
      staff_id: this.props.match.params.staff_id,
      applicability_id: this.props.match.params.applicability_id,
    };
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/relatorio-de-fadiga/administrativo/criar-revisao', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        if (responseJson.status === 'success') {
          var url = '/relatorio-de-fadiga/tripulante/administrativo/editar/' + responseJson.data.id + '/' + responseJson.applicability_id + '/' + responseJson.staff_id;
          var storage = {
            alert_message: responseJson.message,
            alert_type: responseJson.status,
          };
          localStorage.setItem("verify_message", JSON.stringify(storage));
          document.location = url;
        }
        self.setState({overlay: {message: responseJson.message, type: responseJson.status, status: 'open'}});
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  render() {
    var self = this;
    var x = 0;
    return (
<div>
  <Topo promptInstall={this.props.promptInstall}></Topo>
  <RequestApi ref={'request_api'} handleLoaded={this.handleLoaded} />
  <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
  <div className="container-liquid">
    <div className="conteudo">
      <h3 className="page-title pull-left">{this.locale.RelatoriosDeFadiga.EditarRelatorioDeFadigaAdministrador.titulo} {this.state.data.revision} - {this.state.staff_name}</h3>
      <Link to="/administrativo/relatorio-de-fadiga/cadastrar" className="btn btn-default pull-right"><i className="fa fa-chevron-left"></i> {this.locale.general.voltar}</Link>
      <div className="clearfix"></div>
      <hr/>
      <div>
        <p>{this.locale.RelatoriosDeFadiga.EditarRelatorioDeFadigaAdministrador.paragrafoStatusDaRevisao}: {self.state.data.revision_status}</p>
        <p>{this.locale.RelatoriosDeFadiga.EditarRelatorioDeFadigaAdministrador.paragrafoQuantidadeDePontosAtual}: {self.state.data.actual_points_str}</p>
        <p>{this.locale.RelatoriosDeFadiga.EditarRelatorioDeFadigaAdministrador.paragrafoQuantidadeDePontosReportados}: {self.state.data.report_points_str}</p>
      </div>
      <hr/>
      <Tabs activeKey={this.state.key} onSelect={this.handleNavTab.bind(this, 'key')} id="controlled-tab-example">
        {Object.keys(self.state.revisions_data).map(function(k) {
          x = x + 1;
          return (
            <Tab eventKey={x} title={self.locale.RelatoriosDeFadiga.EditarRelatorioDeFadigaAdministrador.tabRevisao.tituloTab + self.state.revisions_data[k].revision}>
              <p>{self.locale.RelatoriosDeFadiga.EditarRelatorioDeFadigaAdministrador.tabRevisao.paragrafoStatusDaRevisao}: {self.state.revisions_data[k].revision_status}</p>
              <p>{self.locale.RelatoriosDeFadiga.EditarRelatorioDeFadigaAdministrador.tabRevisao.paragrafoQuantidadeDePontosAtual}: {self.state.revisions_data[k].actual_points_str}</p>
              <p>{self.locale.RelatoriosDeFadiga.EditarRelatorioDeFadigaAdministrador.tabRevisao.paragrafoQuantidadeDePontosReportados}: {self.state.revisions_data[k].report_points_str}</p>
            </Tab>
          );
        })}
      </Tabs> 
      <hr/>
      <h4>{this.locale.RelatoriosDeFadiga.EditarRelatorioDeFadigaAdministrador.tituloCriarRevisao}</h4>
      <hr/>
      {self.state.data_permission === 1 ? 
        <form onSubmit={self.confirmCreate}>
          {Object.keys(self.state.inputs).map(function(k) {
            return (
              <div className="form-group">
                <label>{self.state.inputs[k].name + " - " + self.state.inputs[k].type_str}</label>
                {(self.state.inputs[k].type === 'options') ? 
                  <Select
                    className="form-field-name"
                    name="type"
                    value={self.state.inputs[k].value_input}
                    required={self.state.inputs[k].required}
                    searchable={true}
                    placeholder={self.locale.RelatoriosDeFadiga.EditarRelatorioDeFadigaAdministrador.formularioCriarRevisao.placeholder.SelecionarOpcao}
                    onChange={self.handleSelectChange.bind(self, self.state.inputs[k].id)}
                    options={self.state.inputs[k]['fatigue_options']}
                  />
                  : (self.state.inputs[k].type === 'hour') ?
                  <InputMask required={self.state.inputs[k].required} value={self.state.inputs[k].value} maskChar={null} name={"fatigue_reason_" + self.state.inputs[k].id} mask="99:99" className="form-control" onChange={self.handleChange.bind(self, self.state.inputs[k].id)} placeholder={self.locale.RelatoriosDeFadiga.EditarRelatorioDeFadigaAdministrador.formularioCriarRevisao.placeholder.Horas} />
                  :
                  <input required={self.state.inputs[k].required} type="text" name={"fatigue_reason_" + self.state.inputs[k].id} className={"form-control"} placeholder={self.locale.RelatoriosDeFadiga.EditarRelatorioDeFadigaAdministrador.formularioCriarRevisao.placeholder.Quantidade} value={self.state.inputs[k].value} onChange={self.handleChange.bind(self, self.state.inputs[k].id)} />
                }
              </div>
            );
          })}
          <div className="row">
            <div className="col-md-12">
              <button disabled={self.state.data_permission === 0 ? 'disabled' : ""} type="submit" className="btn btn-primary btn-lg btn-block"><i className="fa fa-fw fa-save"></i> {this.locale.RelatoriosDeFadiga.EditarRelatorioDeFadigaAdministrador.formularioCriarRevisao.botaoCriarRevisaoDeRelatorioDeFadiga}</button>
            </div>
          </div>
        </form>
        : ""
      }
    </div>
  </div>
</div>
    );
  }
}

export default StaffRfmsReportAdmEdit;



// WEBPACK FOOTER //
// ./src/Components/StaffRfmsReport/StaffRfmsReportAdmEdit.js